function moveCarousel(direction) {
  const container = document.querySelector('.travel-carousel');
  const scrollAmount = container.offsetWidth + 20; // Inclusief gap van 20px

  if (direction === 1) {
    container.scrollLeft += scrollAmount;
  } else {
    container.scrollLeft -= scrollAmount;
  }
}

document.addEventListener("DOMContentLoaded", function() {
    let section = document.querySelector(".section-template--24086810067270__custom_liquid_HCCL3-padding");

    if (!section) {
        console.log("Sectie niet gevonden! Controleer de classnaam.");
        return;
    }

    function checkVisibility() {
        let rect = section.getBoundingClientRect();
        let windowHeight = window.innerHeight;

        if (rect.top < windowHeight - 100) {
            section.classList.add("visible");
            console.log("Sectie zichtbaar! Fade-in effect toegepast.");
            window.removeEventListener("scroll", checkVisibility); // Verwijder event listener na activeren
        }
    }

    window.addEventListener("scroll", checkVisibility);
    checkVisibility(); // Directe check bij laden van de pagina
});





